import { IIconProps } from "../types"

export default function IconLL4(props: IIconProps) {
  const width = props.size || props.width || 61
  const height = props.size || props.height || 82
  return (
    <svg
      {...props}
      width={width}
      height={height}
      className={props.className}
      style={props.style}
      viewBox="0 0 61 82"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M37.6034 1.86944C33.4634 0.409436 30.4734 0.0794365 27.5434 0.859436C24.6134 1.64944 21.7434 3.52944 18.8134 5.44944C15.8834 7.37944 12.8934 9.32944 10.3234 11.2794C7.75336 13.2294 5.60336 15.1894 4.04336 16.8094C2.47336 18.4394 1.50336 19.7394 0.94336 22.1194C0.39336 24.4994 0.26336 27.9494 0.75336 32.4694C1.24336 36.9994 2.34336 42.5994 4.13336 48.8494C5.92336 55.0994 8.40336 61.9994 10.5834 67.1394C12.7634 72.2794 14.6534 75.6694 17.0934 77.9194C19.5334 80.1594 22.5334 81.2694 25.9134 81.3294C29.3034 81.3994 33.0734 80.4194 36.1334 78.8594C39.1934 77.2994 41.5434 75.1494 43.7834 71.4394C46.0334 67.7294 48.1834 62.4494 50.5234 55.7494C52.8634 49.0394 55.4034 40.8994 57.1034 34.8494C58.7934 28.7894 59.6334 24.8194 59.7634 21.5394C59.9034 18.2494 59.3134 15.6394 57.9434 13.5894C56.5834 11.5394 54.4334 10.0394 50.7234 7.98944C47.0134 5.93944 41.7334 3.33944 37.6034 1.86944Z"
        fill="#E6E6E6"
        stroke="black"
        strokeWidth="0.9"
        strokeMiterlimit="2.61313"
      />
    </svg>
  )
}
